export default {
      id: "oc-res-monitoroverview-usage",
      viewBox: "0 0 1047 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-monitoroverview",
      toString: function () {
        return this.url;
      }
    }